<template>
  <div id="app">
    <router-view />
    <div class="suspend" v-if="!isLoginPage">
      <img
        src="/images/suspend/Frame 1618872296@2x.png"
        style="width: 60px; height: 263px; object-fit: cover;"
        alt="Logo"
        class="modal-logo"
      />
      <div class="phone" @click="showPhoneModal = true"></div>
      <div class="qrcode" @click="showQrCodeModal = true"></div>
    </div>

    <!-- 二维码弹窗 -->
    <div
      v-if="showQrCodeModal"
      class="qr-modal-overlay"
      @click="showQrCodeModal = false"
    >
      <div class="qr-modal-content" @click.stop>
                <img
          src="/images/suspend/logo.png"
          alt="Logo"
          class="logo"
        />
        <img 
          src="/images/suspend/二维码_bg.png" 
          alt="背景" 
          class="qr-modal-bg" 
        />
        <div class="qr-modal-header">
          <h3 class="qr-modal-title">添加您的专属顾问</h3>
          <p class="qr-modal-subtitle">- 扫一扫 -</p>
        </div>
        <img 
          v-if="wxwork" 
          :src="wxwork" 
          alt="二维码" 
          class="qr-modal-qrcode" 
        />
        <img 
          v-else 
          src="/images/suspend/qrcode.jpg" 
          alt="二维码" 
          class="qr-modal-qrcode" 
        />
        <p class="qr-modal-footer-text">我们解决的不止是知识产权的问题</p>
      </div>
    </div>

    <!-- 电话咨询弹窗 -->
    <div
      v-if="showPhoneModal"
      class="phone-modal-overlay"
      @click="showPhoneModal = false"
    >
      <div class="phone-modal-content" @click.stop>
        <div class="phone-modal-bg"></div>

        <img
          src="/images/suspend/image 106@2x.png"
          alt="机器人"
          class="phone-modal-robot"
        />
        <div class="phone-modal-title">- 联系我们，解决您更多的经营问题 -</div>
        <div class="phone-modal-subtitle">
          Contact us for more intellectual property solutions
        </div>
        <div class="phone-modal-number">{{ phoneNumber }}</div>
        <button class="phone-modal-copy-btn" @click="copyPhoneNumber">
          复制号码
        </button>
        <button class="phone-modal-close" @click="showPhoneModal = false">
          <span>×</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "App",
  data() {
    return {
      showQrCodeModal: false,
      showPhoneModal: false,
      phoneNumber: "17784713332",
      wxwork: "",
    };
  },
  computed: {
    isLoginPage() {
      return this.$route.path === "/login";
    },
  },
  async created() {
    await this.initPhoneNumber();
  },
  methods: {
    async initPhoneNumber() {
      const cachedPhone = localStorage.getItem("cachedPhoneNumber");
      const cachedWxwork = localStorage.getItem("wxwork");

      if (cachedPhone && cachedWxwork) {
        this.phoneNumber = cachedPhone;
        this.wxwork = cachedWxwork;
        return;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");

      if (code) {
        try {
          const response = await axios.get(
            `https://aimb.douchen.ren/prod-api/system/user/queryWxworkByCode?empId=${code}`
          );
          const result = response.data;

          if (result.code === 200 && result.data && result.data.phone) {
            this.phoneNumber = result.data.phone;
            this.wxwork = result.data.wxwork;
            localStorage.setItem("cachedPhoneNumber", result.data.phone);
            localStorage.setItem("wxwork", result.data.wxwork);
          }
        } catch (error) {
          console.error("获取手机号失败:", error);
        }
      }
    },

    copyPhoneNumber() {
      navigator.clipboard
        .writeText(this.phoneNumber)
        .then(() => {
          alert("号码已复制到剪贴板");
        })
        .catch((err) => {
          console.error("复制失败:", err);
        });
    },
  },
};
</script>

<style  lang="scss">

.suspend {
  position: fixed;
  top: 50%;
  right: 50px;
  /* background-color: rgba(0, 0, 0, 0.5); */
  z-index: 9999;


  .phone {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 143px;
    left: 0;
    right: 0;
    margin: auto;
  }
  .qrcode {
    width: 40px;
    height: 40px;
    position: absolute;
    bottom: 25px;
    left: 0;
    right: 0;
    margin: auto;
  }
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
}

#app {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}

/* 二维码弹窗样式 */
.qr-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  animation: fadeIn 0.3s ease;
}

.qr-modal-content {
  position: relative;
  animation: zoomIn 0.3s ease;
  left: 30px;

  .logo{
    position: absolute;
    width: 130px;
    top: 80px;
    left: 20px;
    margin: auto;
  }
}

.qr-modal-bg {
  display: block;
  max-width: 400px;
  width: auto;
  height: auto;
}

.qr-modal-qrcode {
  position: absolute;
  top: 270px;
  left: 45%;
  transform: translateX(-50%);
  width: 150px;
  height: 150px;
  object-fit: contain;
  border:1px solid #0000003f;
}

.qr-modal-header {
  position: absolute;
  top: 200px;
  left: -10%;
  right: 0;
  text-align: center;
}

.qr-modal-title {
  font-size: 20px;
  font-weight: bold;
  color: #000000;
  margin: 0 0 8px 0;
}

.qr-modal-subtitle {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
}

.qr-modal-footer-text {
  position: absolute;
  bottom: 30px;
  left: -45px;
  right: 0;
  text-align: center;
  font-size: 14px;
  color: #666666;
  margin: 0;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* 电话咨询弹窗样式 */
.phone-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  animation: fadeIn 0.3s ease;
}

.phone-modal-content {
  position: relative;
  width: 100%;
  max-width: 400px;
  border-radius: 24px;
  padding: 40px 30px;
  text-align: center;
  animation: zoomIn 0.3s ease;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.phone-modal-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("~@/../public/images/suspend/Group 2449.png") no-repeat;
  background-size: cover;
  border-radius: 24px;
  pointer-events: none;
}

.phone-modal-robot {
  position: relative;
  z-index: 1;
  width: 120px;
  height: 120px;
  margin: -100px auto 20px;
  display: block;
  object-fit: contain;
  top: -20px;
}

.phone-modal-title {
  position: relative;
  z-index: 1;
  font-size: 20px;
  font-weight: bold;
  color: #3b82f6;
  margin-bottom: 8px;
}

.phone-modal-subtitle {
  position: relative;
  z-index: 1;
  font-size: 12px;
  color: #99999981;
  margin-bottom: 30px;
}

.phone-modal-number {
  position: relative;
  z-index: 1;
  font-size: 28px;
  font-weight: bold;
  color: #000;
  padding: 16px 30px;
  border-radius: 12px;
  margin-bottom: 20px;
  display: inline-block;
  border: 2px solid #3b82f6;
}

.phone-modal-copy-btn {
  position: relative;
  z-index: 1;
  width: 239px;
  height: 48px;
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  border: none;
  border-radius: 12px;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
  }

  &:active {
    transform: translateY(0);
  }
}

.phone-modal-close {
  position: absolute;
  bottom: -50px;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 40px;
  border: none;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.7);
    transform: translateX(-50%) scale(1.1);
  }

  span {
    line-height: 1;
  }
}
</style>
